<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.combinedCurve.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div class="handle-box">
            <el-select v-model="query.balanceId" :placeholder="$t('pages.combinedCurve.selectScale')" class="handle-select mr10">
                <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-date-picker v-model="query.Date" type="date" :placeholder="$t('pages.combinedCurve.datePh')" class="handle-select mr10" :picker-options="pickerOptions0"></el-date-picker>
            <el-time-picker v-model="query.startTime" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.combinedCurve.startTimePh')" class="handle-select mr10"></el-time-picker>
            <el-time-picker v-model="query.endTime" format="HH:mm" value-format="HH:mm" :placeholder="$t('pages.combinedCurve.endTimePh')" :picker-options="{
                        selectableRange: `${query.startTime ? query.startTime + ':00' : '00:00:00'}-23:59:00`
                    }" class="handle-select mr10"></el-time-picker>
            <el-button type="primary" icon="el-icon-search" @click="updateCharts">{{$t('pages.combinedCurve.search')}}</el-button>
        </div>
        
        <!-- 流量曲线 -->
        <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div class="chart-title">{{$t('pages.combinedCurve.flowCurveTitle')}}</div>
                    <div id="dischargeContainer" style="width: 100%; height: 300px"></div>
                </el-card>
            </el-col>
        </el-row>
        
        <!-- 速度曲线 -->
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div class="chart-title">{{$t('pages.combinedCurve.speedCurveTitle')}}</div>
                    <div id="speedContainer" style="width: 100%; height: 300px"></div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
let echarts = require('echarts/lib/echarts');
// 引入柱状图组件
require('echarts/lib/chart/line');
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

export default {
    name: 'combinedCurve',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            balanceArr: [],
            query: {
                balanceId: '',
                Date: '',
                startTime: '',
                endTime: ''
            },
            // 控制显示的标志（默认同时显示）
            showDischarge: true,
            showSpeed: true,
            // 流量曲线数据
            dischargeXdata: [],
            dischargeYdata: [],
            // 速度曲线数据
            speedXdata: [],
            speedYdata: []
        };
    },
    created() {
        this.query.Date = dateFormat.formatDate(new Date(), 'yyyy-MM-dd');
        this.getBalance();
    },
    mounted: function () {
        // 初始化两个图表
    },
    methods: {
        updateCharts() {
            if (this.query.balanceId == '') {
                this.$notify.warning(this.$t('pages.combinedCurve.warn.scaleRequired'));
                return;
            }
            if (this.query.Date == '') {
                this.$notify.warning(this.$t('pages.combinedCurve.warn.dateRequired'));
                return;
            }
            if (this.query.startTime == '') {
                this.$notify.warning(this.$t('pages.combinedCurve.warn.startRequired'));
                return;
            }
            if (this.query.endTime == '') {
                this.$notify.warning(this.$t('pages.combinedCurve.warn.endRequired'));
                return;
            }


            var startTime = this.query.startTime;
            var endTime = this.query.endTime;
            var start = parseFloat(startTime.replace(':', ''));
            var end = parseFloat(endTime.replace(':', ''));
            if (start > end) {
                this.$notify.warning(this.$t('pages.combinedCurve.warn.timeRangeInvalid'));
                return;
            }
            
            this.query.Date = dateFormat.formatDate(new Date(this.query.Date), 'yyyy-MM-dd');
            
            // 默认同时获取和显示两个曲线
            this.getDischargeCurveData();
        },
        
        // 获取流量曲线数据
        getDischargeCurveData() {
            this.$zybhttp
                .post('DataInquiry/DischargeCurve', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var total = res.data.data.total;
                        var data = res.data.data.list;
                        var timeArr = res.data.msg.split(',');
                        var yarr = [];
                        var xarr = [];
                        var timeIndex = 0;
                        var timeName = timeArr[timeIndex];
                        if (total > 7) {
                            for (var i = 0; i < data.length; i++) {
                                // 最后一个数据点使用其实际时间作为x轴标签
                                if (i == data.length - 1) {
                                    // xarr.push(timeName + `_${data[i].name}`);
                                    xarr.push(data[i].name + `_${data[i].name}`);
                                    yarr.push(data[i].value);
                                    continue;
                                }
                                var name = data[i].name;
                                if (name == timeName) {
                                    xarr.push(name + `_${data[i].name}`);
                                    yarr.push(data[i].value);
                                    timeIndex += 1;
                                    timeName = timeArr[timeIndex];
                                    continue;
                                } else {
                                    var nowdate = dateFormat.formatDate(new Date(this.query.Date), 'yyyy-MM-dd');
                                    var ctime = new Date(`${nowdate} ${name}:00`);
                                    var ctimeago = dateFormat.formatDate(dateAdd('n', -1, ctime), 'hh:mm');
                                    if (timeName == ctimeago) {
                                        xarr.push(timeName + `_${data[i].name}`);
                                        timeIndex += 1;
                                        timeName = timeArr[timeIndex];
                                        yarr.push(data[i].value);
                                        continue;
                                    } else {
                                        xarr.push('' + `_${data[i].name}`);
                                    }
                                }
                                yarr.push(data[i].value);
                            }
                        } else {
                            for (var i = 0; i < data.length; i++) {
                                yarr.push(data[i].value);
                                xarr.push(data[i].name + `_${data[i].name}`);
                            }
                        }

                        this.dischargeXdata = xarr;
                        this.dischargeYdata = yarr;
                        this.showDischargeChart();
                        
                        // 同时获取速度曲线数据
                        this.getSpeedCurveData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => {
                    this.$notify.error(this.$t('pages.combinedCurve.fetchFlowError'));
                });
        },
        
        // 获取速度曲线数据
        getSpeedCurveData() {
            this.$zybhttp
                .post('DataInquiry/SpeedCurve', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var total = res.data.data.total;
                        var data = res.data.data.list;
                        var timeArr = res.data.msg.split(',');
                        var yarr = [];
                        var xarr = [];
                        var timeIndex = 0;
                        var timeName = timeArr[timeIndex];
                        if (total > 7) {
                            for (var i = 0; i < data.length; i++) {
                                // 最后一个数据点使用其实际时间作为x轴标签
                                if (i == data.length - 1) {
                                    //xarr.push(timeName + `_${data[i].name}`);                          
                                    xarr.push(data[i].name + `_${data[i].name}`);
                                    yarr.push(data[i].value);
                                    continue;
                                }
                                var name = data[i].name;
                                if (name == timeName) {
                                    xarr.push(name + `_${data[i].name}`);
                                    yarr.push(data[i].value);
                                    timeIndex += 1;
                                    timeName = timeArr[timeIndex];
                                    continue;
                                } else {
                                    var nowdate = dateFormat.formatDate(new Date(this.query.Date), 'yyyy-MM-dd');
                                    var ctime = new Date(`${nowdate} ${name}:00`);
                                    var ctimeago = dateFormat.formatDate(dateAdd('n', -1, ctime), 'hh:mm');
                                    if (timeName == ctimeago) {
                                        xarr.push(timeName + `_${data[i].name}`);
                                        timeIndex += 1;
                                        timeName = timeArr[timeIndex];
                                        yarr.push(data[i].value);
                                        continue;
                                    } else {
                                        xarr.push('' + `_${data[i].name}`);
                                    }
                                }
                                yarr.push(data[i].value);
                            }
                        } else {
                            for (var i = 0; i < data.length; i++) {
                                yarr.push(data[i].value);
                                xarr.push(data[i].name + `_${data[i].name}`);
                            }
                        }

                        this.speedXdata = xarr;
                        this.speedYdata = yarr;
                        this.showSpeedChart();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => {
                    this.$notify.error(this.$t('pages.combinedCurve.fetchSpeedError'));
                });
        },
        
        // 获取设备列表
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        for (var i = 0; i < d.length; i++) {
                            d[i].id = d[i].id + '';
                        }
                        this.balanceArr = d.sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.combinedCurve.fetchDeviceError')));
        },
        
        // 显示流量曲线
        showDischargeChart() {
            var myChart = echarts.init(document.getElementById('dischargeContainer'));
            //定义图表option
            var option = {
                tooltip: {
                    formatter: function (params) {
                        // 自定义X轴坐标点对应的label
                        var name = params[0].name.split('_')[1];
                        var str = `${this.$t('pages.combinedCurve.tooltip.time')}: ${name}<br/>${this.$t('pages.combinedCurve.tooltip.flow')}: ${params[0].value}`;
                        return str;
                    },
                    trigger: 'axis'
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '0%',
                    top: '10%',
                    containLabel: true
                },
                lineStyle: {
                    color: '#FC6FA1'
                },
                xAxis: {
                    type: 'category',
                    data: this.dischargeXdata,
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            return value.split('_')[0];
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#008ACD',
                            width: 1
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#008ACD',
                            width: 1
                        }
                    }
                },
                series: [{
                    symbol: 'circle',
                    type: 'line',
                    color: '#FC6FA1',
                    smooth: true,
                    data: this.dischargeYdata
                }]
            };
            
            myChart.setOption(option);
            myChart.resize();
            
            // 监听窗口大小变化，重新调整图表大小
            window.addEventListener('resize', () => {
                myChart.resize();
            });
        },
        
        // 显示速度曲线
        showSpeedChart() {
            var myChart = echarts.init(document.getElementById('speedContainer'));
            //定义图表option
            var option = {
                tooltip: {
                    formatter: function (params) {
                        // 自定义X轴坐标点对应的label
                        var name = params[0].name.split('_')[1];
                        var str = `${this.$t('pages.combinedCurve.tooltip.time')}: ${name}<br/>${this.$t('pages.combinedCurve.tooltip.speed')}: ${params[0].value}`;
                        return str;
                    },
                    trigger: 'axis'
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '0%',
                    top: '10%',
                    containLabel: true
                },
                lineStyle: {
                    color: '#2DB4F2'
                },
                xAxis: {
                    type: 'category',
                    data: this.speedXdata,
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            return value.split('_')[0];
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#008ACD',
                            width: 1
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#008ACD',
                            width: 1
                        }
                    }
                },
                series: [{
                    symbol: 'circle',
                    type: 'line',
                    color: '#2DB4F2',
                    smooth: true,
                    data: this.speedYdata
                }]
            };
            
            myChart.setOption(option);
            myChart.resize();
            
            // 监听窗口大小变化，重新调整图表大小
            window.addEventListener('resize', () => {
                myChart.resize();
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
    margin-left: 20%;
}

.handle-select {
    width: 200px;
}

.mr10 {
    margin-right: 10px;
}

.schart {
    width: 100%;
    height: 300px;
}

.chart-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    text-align: center;
}
</style>
